<div
  class="ui attached segment"
  appMargin
  marginT="5"
  style="border: 1px solid #dcdcdc; border-radius: 4px"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <!-- <div fxFlex="3%">
      <sui-checkbox> </sui-checkbox>
    </div> -->
    <div fxFlex="20">{{ department?.invoiceNumber }}</div>
    <div fxFlex="40">{{ department?.categoryName }}</div>
    <div fxFlex="20">
      {{ department?.currencyCode }} {{ department?.amount | number: ".2-2" }}
    </div>
    <div fxFlex="15">
      {{ department?.currencyCode }}
      {{ department?.outstandingAmount | number: ".2-2" }}
    </div>
    <div fxFlex="10">{{ department?.noOfPayments }}</div>
    <div fxFlex="15">
      <span
        class="ui circular label"
        [ngClass]="{
          red: department?.status == 'CANCELLED',
          green: department?.status == 'PAID',
          yellow: department?.status == 'UNPAID'
        }"
        >{{ department?.status }}</span
      >
    </div>
    <div fxFlex="15%" class="text-right">
      <a
        suiPopup
        popupText="Pay Invoice"
        popupInverted
        popupPlacement="button"
        class="ui circular tiny button"
        style="padding: 0.5em"
        *ngIf="
          department?.status != 'PAID' &&
          department?.status != 'OVER_PAID' &&
          department?.status != 'CANCELLED'
        "
        (click)="onPayNow.emit(department)"
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.57936 7.01172H17.2044M2.57936 7.57422H17.2044M4.82936 11.5117H9.32936M4.82936 13.1992H7.07936M4.26686 15.4492H15.5169C16.4488 15.4492 17.2044 14.6937 17.2044 13.7617V5.88672C17.2044 4.95474 16.4488 4.19922 15.5169 4.19922H4.26686C3.33488 4.19922 2.57936 4.95474 2.57936 5.88672V13.7617C2.57936 14.6937 3.33488 15.4492 4.26686 15.4492Z"
            stroke="#86879D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      <a
        suiPopup
        popupText="View Invoice"
        popupInverted
        popupPlacement="button"
        class="ui circular tiny button"
        (click)="onView.emit(department)"
        ><i class="eye icon"></i
      ></a>
      <button
        class="ui circular tiny button"
        (click)="onDownload.emit(department)"
        suiPopup
        popupText="Download Invoice"
        popupInverted
        popupPlacement="button"
      >
        <i class="download icon"></i>
      </button>
      <button
        class="ui circular tiny button"
        (click)="toggleEquipment()"
        suiPopup
        popupText="View Invoice Transactions"
        popupInverted
        popupPlacement="button"
      >
        <i
          [ngClass]="
            collapseEquipment ? 'chevron down icon' : 'chevron up icon'
          "
        ></i>
      </button>
    </div>
  </div>
</div>

<div [suiCollapse]="collapseEquipment">
  <div
    class="ui bottom attached segment"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <app-admin-invoice-unit
      [units]="units"
      [currency]="department.currencyCode"
      [customerNCCID]="department.nccId"
      [invoiceNumber]="department.invoiceId"
      *ngIf="units.length > 0"
    ></app-admin-invoice-unit>
    <!-- <div class="ui basic segment" *ngIf="units.length < 1">
			<div class="ui primary centered header">No equipment to display</div>
		</div> -->
  </div>
</div>
